// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__18WZM","buttons":"SendReceipts_buttons__23SEW","email":"SendReceipts_email__2IHDH","bookApptTitle":"SendReceipts_bookApptTitle__3d8qa"};